'use client';

import dynamic from 'next/dynamic';
import { VirtualTourProps } from '@/types/model';

// Carga three.js solo al entrar a esta pagina: Next 16 no permite ssr:false
// desde un Server Component, asi que el dynamic vive en este wrapper cliente.
const VirtualTour = dynamic(() => import('@/components/VirtualTour'), { ssr: false });

const VirtualTourLoader = (props: VirtualTourProps) => <VirtualTour {...props} />;

export default VirtualTourLoader;
